import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../styles/ProductAndService.css";
import * as atlas from "azure-maps-control";


import RobotaxiLogin from "../../../Images/Robo_Taxi.png";
import finTransServ from "../../../Images/Finance-Transaction_Image.png";
import saas from "../../../Images/Saas_Image.png";
import realTimeParking from "../../../Images/Realtime_Parking_Image.png";
import inspection from "../../../Images/Inspection_Collabaration.png";
import cleaning from "../../../Images/Cleaning_Service.png";
import aiML from "../../../Images/AI&ML_Image.png";
// import contactUS from "../../../Images/Contact_Us.png";
// import mapPin from "../../../Images/Map_Pin.png";

const ProductsAndServices = () => {
  useEffect(() => {
      const map = new atlas.Map('azureMap', {
        center: [-122.2003, 47.618390], // Corrected Longitude, Latitude of the location
        zoom: 15,
        language: 'en-US',
        authOptions: {
          authType: 'subscriptionKey',
          subscriptionKey: 'iKSTDEFy2eA9QfhSETwDwwnQoR_36iCV5wv18ubSOBw'
        }
      });
  
      map.events.add('ready', () => {
        map.markers.add(new atlas.HtmlMarker({
          position: [-122.201240, 47.617669], // Corrected Longitude, Latitude of the location
          popup: new atlas.Popup({
            content: '<div style="padding:10px">800 Bellevue Way NE, Suite #500, Bellevue, WA 98004, USA</div>',
            pixelOffset: [0, -30]
          })
        }));
      });
    }, []);
  
    const openMapInNewTab = () => {
      window.open(`https://www.bing.com/maps?q=800+Bellevue+Way+NE,+Suite+%23500,+Bellevue,+WA+98004,+USA`, '_blank');
    };

  return (
    <>
      <Header />

      {/* ✅ Hero Section */}
      <section className="hero-section">
        <img src={RobotaxiLogin} alt="Hero" className="hero-img" />
        <div className="hero-overlay">
          <h1>Product and Services</h1>
          <p>
            Empowering Robotaxi operators and Parking Lot Owners with
            intelligent, cloud-based solutions for seamless parking management.
          </p>
        </div>
      </section>

      <main className="services-main">

        {/* ✅ Service 1 */}
        <div className="service-block">
          <div className="service-img">
            <img src={finTransServ} alt="Financial Transaction Service" />
          </div>
          <div className="service-text">
            <p className="tagline">
              Seamless, secure, and real-time parking transactions.
            </p>
            <h2>Financial Transaction Services</h2>
            <p>
              GeoParking offers comprehensive financial transaction services that facilitate seamless commercial transactions
               between Robotaxi operators and parking lot owners/managers. Our cloud-based software provides real-time 
               availability for parking spaces, ensuring efficient management of parking needs.
            </p>
          </div>
        </div>

        {/* ✅ Service 2 */}
        <div className="service-block reverse">
          <div className="service-text">
            <p className="tagline">
              A scalable B2B platform for Robotaxi and AV parking operations.
            </p>
            <h2>Software as a Service (SaaS)</h2>
            <p>
              GeoParking provides a B2B Software as a Service (SaaS) for Robotaxi companies and privately owned Autonomous 
              Vehicles via the AV manufacturers. This software offers information about the availability of parking spaces 
              for efficiently managing parking and parking lot needs.
            </p>
          </div>
          <div className="service-img">
            <img src={saas} alt="SaaS" />
          </div>
        </div>

        {/* ✅ Service 3 */}
        <div className="service-block">
          <div className="service-img">
            <img src={realTimeParking} alt="Real-Time Parking" />
          </div>
          <div className="service-text">
            <p className="tagline">
              Stay updated. Always know where and when to park.
            </p>
            <h2>Real-Time Parking Information</h2>
            <p>
              Access real-time data on the location, availability, 
              and cost of designated Robotaxi/AV-only parking areas.
            </p>
          </div>
        </div>

        {/* ✅ Service 4 */}
        <div className="service-block reverse">
          <div className="service-text">
            <p className="tagline">
              Keeping every Robotaxi in top condition.
            </p>
            <h2>Inspection and Calibration</h2>
            <p>
              Ensure your Robotaxi/eAVs are always in top condition with our inspection and calibration services.
            </p>
          </div>
          <div className="service-img">
            <img src={inspection} alt="Inspection" />
          </div>
        </div>

        {/* ✅ Service 5 */}
        <div className="service-block">
          <div className="service-img">
            <img src={cleaning} alt="Cleaning Services" />
          </div>
          <div className="service-text">
            <p className="tagline">
                Fleet-ready, spotless, and operational.                    
             </p>
            <h2>Cleaning Services</h2>
            <p>
              Keep your Robotaxi/AV fleet clean with our washing and cleaning services.
            </p>
          </div>
        </div>

        {/* ✅ Service 6 */}
        <div className="service-block reverse">
          <div className="service-text">
            <p className="tagline">
              Intelligence that drives efficiency.
            </p>
            <h2>AI and Machine Learning</h2>
            <p>
              Our platform uses AI and machine learning to optimize current & future parking availability, 
              providing Robotaxi companies with the highest operational efficiencies.
            </p>
          </div>
          <div className="service-img">
            <img src={aiML} alt="AI and ML" />
          </div>
        </div>

        <section className="contact-section">
  <div className="contact-wrapper">

    {/* ✅ Move Text First */}
    <div className="contact-overlay">
      <h2>Contact Us</h2>
      <p className="contact-sub">
        We’re here to support your journey into the future of parking.
      </p>

      <div className="contact-details">
        <h4>ADDRESS</h4>
        <p>
          GeoParking Technologies, Inc. <br />
          800 Bellevue Way NE, Suite #500 <br />
          Bellevue, WA 98004, U.S.A
        </p>

        <h4>PHONE</h4>
        <p>+1 (425) 459-8400</p>

        <h4>EMAIL</h4>
        <p className="underline"><a href="mailto:parking@geoparking.com">Parking@Geoparking.com</a></p>

        <h4>WEBSITE</h4>
        <p className="underline"><a href="https://www.Geoparking.com">www.Geoparking.com</a></p>
      </div>
    </div>

    {/* ✅ Map Second */}
    <div className="contact-us-map">
      <div id="azureMap" className="azure-map"></div>
      <button className="map-button" onClick={openMapInNewTab}>Open Map in New Tab</button>
    </div>
  
  </div>
  </section>  
      </main>
      <Footer />
    </>
  );
};

export default ProductsAndServices;
